<app-dialog [title]="'Upgrade Now'" [actions]="actions" (action)="action($event)" (close)="close()" [hideCloser]="hideCloser">
    <div class="container">
        <mat-tab-group [selectedIndex]="tabIndex">
            <mat-tab>
                <mat-radio-group aria-label="Select an option" [formControl]="radio">
                    <mat-radio-button value="1" [checked]="true">
                        <div class="radio">
                            <div class="radio_title">Upgrade to premium ($249/Month)</div>
                            <div class="radio_description">For the first month you will be charged partially</div>
                        </div>
                    </mat-radio-button>
                    <mat-radio-button value="2" [disabled]="userInfo && (userInfo.freemiumAvail || userInfo.isShipyard == null)">
                        <div class="radio">
                            <div class="radio_title">Buy a single shipment create ($125)</div>
                            <div class="radio_description" *ngIf="userInfo && userInfo.freemiumAvail">You already have a credit available. You can have 1 credit at a time.</div>
                        </div>
                    </mat-radio-button>
                </mat-radio-group>

                <div class="credit-card" *ngIf="lastFour">
                    <div class="credit-card_number">{{ccName}}</div>
                    <div class="credit-card_number">
                        <div class="credit-card_stars">**** **** ****</div>
                        {{lastFour}}
                    </div>
                </div>
            </mat-tab>

            <mat-tab>
                <div class="container">
                    <i class="icon" [ngClass]="{'icon--check': !error, 'icon--error': error}"></i>
                    <div class="line">
                        {{responseMessage}}
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

</app-dialog>
